import * as mod from 'common-ui/lib/common/CommonElements/Breadcrumbs';

export default mod.default;
